namespace SorAraBul.Web.Services.SorsReportCallback {
    export interface SorsReportReadyResponse extends Serenity.ServiceResponse {
        Success?: boolean;
        TenantId?: number;
        Status?: TenantStatus;
        Message?: string;
    }
}
